import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import { DropzoneInputProps } from 'react-dropzone';
import styled from 'styled-components';

export const StyledDropzoneContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  outline: none;
  border-radius: 13px;
`;

const getDashedBorderSvg = (borderColor: string) => {
  const color = encodeURIComponent(borderColor);
  return `"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='13' ry='13' stroke='${color}' stroke-width='4' stroke-dasharray='12' stroke-dashoffset='12' stroke-linecap='square'/%3e%3c/svg%3e"`;
};

interface StyledDropzoneInputProps extends DropzoneInputProps {
  isDragAccept: boolean;
  isDragReject: boolean;
}

export const StyledDropzoneContent = styled(Grid)`
  height: 100%;
  outline: none;
  background-image: url(${getDashedBorderSvg(RoutalPalette.grey12)});
  border-radius: inherit;
  background-color: transparent;
  transition: border 0.25s;
  cursor: pointer;
  :hover {
    background-image: url(${getDashedBorderSvg(RoutalPalette.grey7)});
  }
  ${(props: StyledDropzoneInputProps) => {
    if (props.isDragAccept) {
      return `
        background-image: url(${getDashedBorderSvg(RoutalPalette.success.medium)});
        background-color: ${RoutalPalette.success.medium}25;
      `;
    }
    if (props.isDragReject) {
      return `
        background-image: url(${getDashedBorderSvg(RoutalPalette.error.medium)});
        background-color: ${RoutalPalette.error.medium}25;
      `;
    }
    return ``;
  }}
`;
